const CHARACTERS = [
  {
    name: "林小满",
    role: "主角 · 温柔内向",
    img: "https://readdy.ai/api/search-image?query=Stylized%20anime%20manga%20character%20portrait%20of%20a%20kind-hearted%20young%20male%20college%20student%20with%20messy%20dark%20brown%20hair%20and%20warm%20amber%20eyes%2C%20gentle%20shy%20smile%2C%20wearing%20casual%20beige%20hoodie%2C%20warm%20cream%20studio%20background%20with%20soft%20pink%20and%20gold%20accents%2C%20romantic%20webtoon%20art%20style%2C%20clean%20detailed%20illustration%2C%20no%20text&width=600&height=720&seq=lovecomic-char1&orientation=portrait",
    desc: "图书馆常客，说话容易脸红。捡到恋爱辅助器后，开始学着迈出舒适圈，一步步变得更勇敢也更真诚。",
    tone: "bg-primary-100 text-primary-700",
  },
  {
    name: "沈星",
    role: "女主 · 元气明朗",
    img: "https://readdy.ai/api/search-image?query=Stylized%20anime%20manga%20character%20portrait%20of%20a%20cheerful%20short-haired%20girl%20with%20warm%20brown%20bob%20haircut%20and%20bright%20coral%20eyes%2C%20playful%20confident%20smile%2C%20wearing%20soft%20white%20sweater%2C%20warm%20cream%20background%20with%20golden%20sparkles%2C%20romantic%20webtoon%20art%20style%2C%20clean%20detailed%20illustration%2C%20no%20text&width=600&height=720&seq=lovecomic-char2&orientation=portrait",
    desc: "永远笑着出现的阳光少女。喜欢美食与拍照，是主角被辅助器「锁定」的心动对象，却有着不为人知的柔软一面。",
    tone: "bg-accent-100 text-accent-700",
  },
  {
    name: "小爱",
    role: "恋爱辅助器 · 系统精灵",
    img: "https://readdy.ai/api/search-image?query=Cute%20stylized%20anime%20mascot%20character%20of%20a%20small%20round%20floating%20heart-shaped%20AI%20assistant%20with%20tiny%20golden%20wings%20and%20rosy%20cheeks%20holding%20a%20small%20golden%20heart%2C%20warm%20cream%20background%20with%20coral%20and%20gold%20accents%2C%20kawaii%20webtoon%20art%20style%2C%20clean%20detailed%20illustration%2C%20no%20text&width=600&height=720&seq=lovecomic-char3&orientation=portrait",
    desc: "居住在辅助器里的系统精灵，毒舌又傲娇，却总在最关键的时刻给出暖心的提示，是全作的「剧情解说担当」。",
    tone: "bg-secondary-100 text-secondary-700",
  },
  {
    name: "顾言",
    role: "劲敌 · 冷静学霸",
    img: "https://readdy.ai/api/search-image?query=Stylized%20anime%20manga%20character%20portrait%20of%20a%20cool%20handsome%20young%20man%20with%20slicked%20dark%20hair%20and%20sharp%20brown%20eyes%2C%20calm%20confident%20expression%2C%20wearing%20elegant%20black%20coat%2C%20warm%20cream%20background%20with%20amber%20accents%2C%20romantic%20webtoon%20art%20style%2C%20clean%20detailed%20illustration%2C%20no%20text&width=600&height=720&seq=lovecomic-char4&orientation=portrait",
    desc: "成绩优异、行事冷静，同样对沈星有好感。与主角构成鲜明的对比，也推动了不少关键剧情走向。",
    tone: "bg-primary-100 text-primary-700",
  },
  {
    name: "苏桃",
    role: "闺蜜 · 元气助攻",
    img: "https://readdy.ai/api/search-image?query=Stylized%20anime%20manga%20character%20portrait%20of%20a%20friendly%20warm%20young%20woman%20with%20long%20wavy%20auburn%20hair%20and%20gentle%20smile%2C%20wearing%20cozy%20caramel%20sweater%2C%20warm%20cream%20background%20with%20pink%20accents%2C%20romantic%20webtoon%20art%20style%2C%20clean%20detailed%20illustration%2C%20no%20text&width=600&height=720&seq=lovecomic-char5&orientation=portrait",
    desc: "沈星的多年闺蜜，心思细腻、最爱吃瓜。常在幕后悄悄助攻，也是主角获得勇气的重要助力。",
    tone: "bg-accent-100 text-accent-700",
  },
  {
    name: "陆沉",
    role: "学长 · 温柔引路人",
    img: "https://readdy.ai/api/search-image?query=Stylized%20anime%20manga%20character%20portrait%20of%20a%20mature%20elegant%20young%20man%20with%20neat%20dark%20hair%20and%20warm%20golden%20eyes%2C%20gentle%20serious%20expression%2C%20wearing%20white%20shirt%2C%20warm%20cream%20background%20with%20soft%20gold%20accents%2C%20romantic%20webtoon%20art%20style%2C%20clean%20detailed%20illustration%2C%20no%20text&width=600&height=720&seq=lovecomic-char6&orientation=portrait",
    desc: "成熟可靠的学长，看似局外人却深谙情感之道。他的经历揭开了恋爱辅助器更深层的秘密。",
    tone: "bg-secondary-100 text-secondary-700",
  },
];

export default function Characters() {
  return (
    <section id="characters" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
            <i className="ri-group-2-line"></i>
            主要人物
          </span>
          <h2 className="mt-5 font-heading text-3xl leading-snug text-foreground-900 md:text-4xl">
            角色<span className="text-primary-600">介绍</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            一段好的恋爱故事，少不了鲜活的人物。认识这群在云川市相遇、成长、彼此照亮的人吧。
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {CHARACTERS.map((c) => (
            <article
              key={c.name}
              className="group overflow-hidden rounded-3xl border border-background-200 bg-background-50"
            >
              <div className="relative h-72 overflow-hidden sm:h-80">
                <img
                  src={c.img}
                  alt={`恋爱辅助器漫画角色 ${c.name} - ${c.role}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className={`absolute left-4 top-4 rounded-full px-3 py-1 text-xs font-medium ${c.tone}`}>
                  {c.role}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-xl text-foreground-900">{c.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}